import React, { useState, useEffect } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import transactionTopics from "../../data/Manitoba/transactionTopics.js";

export default function TRESA({ setProvince }) {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  // Add CSS for accordion content
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      .accordion-content ol {
        margin-left: -15px !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const [TransactionTopic, setTransactionTopic] = useState("");
  const [expandedAccordion, setExpandedAccordion] = useState(false);

  const handleTransactionTopic = (e) => {
    setTransactionTopic(
      transactionTopics.filter((topic) => topic.id === e.target.value)
    );
    setExpandedAccordion(false);
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? panel : false);

    // Scroll to the top of the first accordion when expanded (mobile only)
    if (isExpanded && window.innerWidth <= 768) {
      console.log(
        "Accordion clicked, panel:",
        panel,
        "isExpanded:",
        isExpanded
      );

      // Debug: Check if this is the 2nd accordion
      if (panel === "panel1") {
        console.log("2nd accordion clicked - this is the problematic one");
        console.log("Clicked element:", event.currentTarget);
        console.log(
          "Clicked element data-testid:",
          event.currentTarget.getAttribute("data-testid")
        );
      }

      // Use a longer timeout for iOS and add multiple attempts
      const scrollToFirstAccordion = () => {
        // Try multiple selectors to find the first accordion
        const firstAccordion =
          document.querySelector('[data-testid="accordion-0"]') ||
          document.querySelector(".MuiAccordion-root") ||
          document.querySelector('[role="region"]');
        console.log("Found first accordion:", firstAccordion);

        if (firstAccordion) {
          console.log("Attempting to scroll to first accordion");
          try {
            // Get the position and add offset to position just below header
            const rect = firstAccordion.getBoundingClientRect();
            const scrollTop =
              window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition = scrollTop + rect.top - 80; // 80px offset to position below header

            console.log("Current scroll position:", scrollTop);
            console.log("Accordion rect.top:", rect.top);
            console.log("Target position:", targetPosition);

            // Use requestAnimationFrame for smoother scrolling on iOS
            requestAnimationFrame(() => {
              window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
              });
            });
          } catch (error) {
            console.error("Error scrolling to first accordion:", error);
          }
        } else {
          console.log("No first accordion found, trying fallback");
          // Fallback: try to scroll to the transaction topic container
          const transactionContainer = document.querySelector(".max-w-4xl");
          if (transactionContainer) {
            console.log("Using fallback container");
            const rect = transactionContainer.getBoundingClientRect();
            const scrollTop =
              window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition = scrollTop + rect.top - 80;

            requestAnimationFrame(() => {
              window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
              });
            });
          }
        }
      };

      // First attempt after a longer delay for iOS
      setTimeout(scrollToFirstAccordion, 600);

      // Second attempt as backup for iOS
      setTimeout(scrollToFirstAccordion, 1000);
    }
  };

  useEffect(() => {
    setProvince("MB");
  });

  return (
    <div className="w-full  mt-5 flex flex-col justify-center items-left">
      <div className="flex flex-col">
        <h1 className=" mt-4 mb-2">Transaction Training/Due Diligence</h1>
        <p>
          Select a Transaction Type in the dropdown to learn more about general
          due diligences and strategies for that type of transaction.
        </p>
        <ThemeProvider theme={theme}>
          <FormControl
            sx={{
              ml: 2,
              mt: 2,
              mb: 1,
              minWidth: 360,
              maxWidth: 360,
            }}
          >
            <InputLabel size="small" className="select-default-label">
              Transaction Topic
            </InputLabel>
            <Select
              value={
                TransactionTopic === "" ? "" : TransactionTopic[0]?.id || ""
              }
              name="Transaction Topic"
              label="Transaction Topic"
              onChange={handleTransactionTopic}
              size="small"
              sx={{ borderRadius: 20 }}
              defaultValue={""}
            >
              <MenuItem
                key={Math.random()}
                value="singleFamily"
                style={{ whiteSpace: "normal" }}
              >
                Single Family Residential (Resale)
              </MenuItem>
              <MenuItem
                key={Math.random()}
                value="condo"
                style={{ whiteSpace: "normal" }}
              >
                Residential Condo (Resale)
              </MenuItem>
              <MenuItem
                key={Math.random()}
                value="preconcondo"
                style={{ whiteSpace: "normal" }}
              >
                Pre-Construction (Condos)
              </MenuItem>
              <MenuItem
                key={Math.random()}
                value="FSBO"
                style={{ whiteSpace: "normal" }}
              >
                For Sale by Owner (Residential Resale)
              </MenuItem>
              <MenuItem
                key={Math.random()}
                value="tenantedProperty"
                style={{ whiteSpace: "normal" }}
              >
                Residential (Tenant - Vacant Possession)
              </MenuItem>
              <MenuItem
                key={Math.random()}
                value="mobileManufactured"
                style={{ whiteSpace: "normal" }}
              >
                Mobile, Manufactured, Modular Home
              </MenuItem>
              <MenuItem
                key={Math.random()}
                value="powerofsale"
                style={{ whiteSpace: "normal" }}
              >
                Foreclosures (Power of Sale)
              </MenuItem>
              <MenuItem
                key={Math.random()}
                value="ruralCountry"
                style={{ whiteSpace: "normal" }}
              >
                Rural & Country Properties
              </MenuItem>
              <MenuItem
                key={Math.random()}
                value="cooperative"
                style={{ whiteSpace: "normal" }}
              >
                Co-operative Residential
              </MenuItem>
              <MenuItem
                key={Math.random()}
                value="cottage"
                style={{ whiteSpace: "normal" }}
              >
                Cottage Property
              </MenuItem>
              <MenuItem
                key={Math.random()}
                value="assignment"
                style={{ whiteSpace: "normal" }}
              >
                Assignments (Pre-Construction)
              </MenuItem>
              <MenuItem
                key={Math.random()}
                value="indigenousLand"
                style={{ whiteSpace: "normal" }}
              >
                Reserve Land (Leased Land)
              </MenuItem>
              <MenuItem
                key={Math.random()}
                value="vacantLand"
                style={{ whiteSpace: "normal" }}
              >
                Vacant Land
              </MenuItem>
            </Select>
          </FormControl>
        </ThemeProvider>
      </div>
      {TransactionTopic !== "" && (
        <div className="max-w-5xl w-full flex justify-left mt-5">
          <ThemeProvider theme={theme}>
            <div className="mt-2 mb-1 max-w-5xl">
              <div className="title-header ">
                <h1>{TransactionTopic[0]?.title}</h1>
              </div>
              <div className="mt-2 mb-5">
                <div
                  dangerouslySetInnerHTML={{
                    __html: TransactionTopic[0]?.description,
                  }}
                />
              </div>
              {Array.isArray(TransactionTopic[0]?.text) ? (
                // If text is an array, map through it to create accordions
                TransactionTopic[0].text.map((section, index) => (
                  <Accordion
                    key={index}
                    data-testid={
                      index === 0 ? "accordion-0" : `accordion-${index}`
                    }
                    sx={{
                      mb: 1,
                      borderRadius: "5px 5px 0 0",
                      backgroundColor: "#ffffff",
                      border: "1px solid #e0e0e0",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      "&:hover": {
                        boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
                      },
                      "& .MuiAccordionDetails-root": {
                        padding: "24px 15px 15px 15px",
                      },
                      "&.Mui-expanded": {
                        margin: "8px 0",
                      },
                    }}
                    expanded={expandedAccordion === `panel${index}`}
                    onChange={handleAccordionChange(`panel${index}`)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ color: "#0c0f24" }} />}
                      aria-controls={`${TransactionTopic[0].id}-${index}-content`}
                      id={`${TransactionTopic[0].id}-${index}-header`}
                      sx={{
                        backgroundColor: "#ffffff",
                        borderBottom: "1px solid #e0e0e0",
                        borderTopLeftRadius: "5px",
                        borderTopRightRadius: "5px",
                        minHeight: "48px",
                        height: "48px",
                        "& .MuiAccordionSummary-content": {
                          margin: "8px 0",
                        },
                        "& .MuiAccordionSummary-expandIconWrapper": {
                          transform: "rotate(0deg)",
                          transition: "transform 0.2s ease-in-out",
                        },
                        "&.Mui-expanded .MuiAccordionSummary-expandIconWrapper":
                          {
                            transform: "rotate(180deg)",
                          },
                        "&:hover": {
                          backgroundColor: "rgba(12, 15, 36, 0.1)",
                        },
                        "&.Mui-expanded": {
                          backgroundColor: "rgba(12, 15, 36, 0.1)",
                          minHeight: "48px",
                          height: "48px",
                        },
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "600",
                          color: "#0c0f24",
                          fontSize: "16px",
                          fontFamily: "Manrope, sans-serif",
                        }}
                      >
                        {section.title}
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: section.text,
                        }}
                        style={{
                          lineHeight: 1.6,
                          color: "#31303F",
                        }}
                        className="accordion-content"
                      />
                    </AccordionDetails>
                  </Accordion>
                ))
              ) : (
                // If text is a string, show it directly
                <div className="body pt-4">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: TransactionTopic[0].text,
                    }}
                    style={{
                      lineHeight: 1.6,
                      color: "#31303F",
                    }}
                  />
                </div>
              )}
            </div>
          </ThemeProvider>
        </div>
      )}
    </div>
  );
}

/*

 <MenuItem
                key={Math.random()}
                value="preconfreehold"
                style={{ whiteSpace: "normal" }}
              >
                Pre-Construction (Freehold)
              </MenuItem>
              
               


              <MenuItem
                key={Math.random()}
                value="crownLand"
                style={{ whiteSpace: "normal" }}
              >
                Purchase on Crown Land (Leased Land)
              </MenuItem>
              
              
              */
